import React from 'react';
import { Fleet } from 'models/Fleet';
import {
  LinkToManagers,
  LinkToVehicles,
} from '../components/TableCellContent/TableCellContent.component';

export type TableCols = Array<
  keyof Pick<Fleet, 'name'> | 'linkToVehicles' | 'linkToManagers'
>;

export const columns: TableCols = ['name', 'linkToVehicles', 'linkToManagers'];

export const headingTranslations: Record<TableCols[number], string> = {
  name: 'fleetName',
  linkToVehicles: 'Link to vehicles',
  linkToManagers: 'Link to managers',
};

export const contentTransformations: Record<
  TableCols[number],
  (val: any, config?: Record<string, any>) => React.ReactNode
> = {
  name: (v) => v,
  linkToVehicles: (v, conf) => <LinkToVehicles val={v} config={conf} />,
  linkToManagers: (v, conf) => <LinkToManagers val={v} config={conf} />,
};
